import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

(function () {
    let masonryElement = document.querySelector('.Masonry-images');

    if (!masonryElement) return;

    let msnry = new Masonry(masonryElement, {
        columnWidth: '.Masonry-sizer',
        itemSelector: '.Masonry-image',
        percentPosition: true,
        gutter: 10
    });

    imagesLoaded(masonryElement).on('progress', function () {
        msnry.layout();
    });
})();